export default __webpack_public_path__ + "static/media/puesc-validation-error.5b8756c5.svg";